import { useState } from 'react';
import 'library/helpers/array';

const useIncludedGoals = (initialValues = [], callback) => {
  const [includedGoals, setIncludedGoals] = useState(initialValues);

  const toggleGoal = (goalId) => {
    includedGoals.toggleValues(goalId);
  };

  return {
    toggleGoal,
    includedGoals,
    setIncludedGoals,
  };
};

export default useIncludedGoals;
